import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { NoAccessComponent } from './features/no-access/no-access.component';

@NgModule({
  declarations: [App, NoAccessComponent],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    MatSnackBarModule,
    TranslateModule.forRoot({ fallbackLang: 'en' }),
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideTranslateHttpLoader({ prefix: '/assets/i18n/', suffix: '.json' }),
    // PWA runtime (prod/staging builds only — dev has no ngsw-worker.js).
    // Points at the same combined worker main.ts registers early, so this call
    // reuses that registration; its real job is enabling the SwUpdate channel.
    provideServiceWorker('mobimed-sw.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
      // Must match main.ts — the last register() call's options win, and the
      // default ('imports') lets HTTP caching pin the imported workers.
      updateViaCache: 'none',
    }),
  ],
  bootstrap: [App],
})
export class AppModule {}
